<template>
    <div class="text-a-brown-502314  py-3 border-b border-a-brown-d7c7b8" v-if="cartItemAdjust">
        <div class="flex flex-wrap"
            :class="{'opacity-40': cartItem.cartInvalidErrorMessage != null}">
            <div class="wrapper-order">
                <div class="name-order text-14 mb-1 lg:text-16">{{getName()}}</div>
                <div
                    v-for="(addon,addonIndex) in cartItemAdjust.remark ? cartItemAdjust.remark.addons : []"
                    :key="addonIndex"
                    class="text-14 lg:text-16"
                >
                    {{ localeCode === 1033 ? addon.header_en : addon.header }}
                    <div v-for="(addonItem, addonItemIndex) in addon.items"
                        :key="addonItemIndex"
                        class="text-a-brown-9f8273 text-12 lg:text-14"
                    >
                    {{FilterNumberFormat(addonItem.quantity)}} x {{localeCode === 1033 ? addonItem.name_en : addonItem.name}} {{ getPriceOption(addonItem) }}</div>
                </div>
                <div
                    v-for="(appetizer,appetizerIndex) in cartItemAdjust.remark ? cartItemAdjust.remark.appetizers : []"
                    :key="appetizerIndex"
                    class="text-14 lg:text-16"
                >
                    {{ localeCode === 1033 ? appetizer.header_en : appetizer.header }}
                    <div v-for="(appetizerItem, appetizerItemIndex) in appetizer.items"
                        :key="appetizerItemIndex"
                        class="text-a-brown-9f8273 text-12 lg:text-14"
                    >{{FilterNumberFormat(appetizerItem.quantity)}} x {{localeCode === 1033 ? appetizerItem.name_en : appetizerItem.name}} {{ getPriceOption(appetizerItem) }}</div>
                </div>
            </div>
            <div class="wrapper-control" v-if="reload">
                <div class="flex w-full">
                    <img v-if="cartItem.cartInvalidErrorMessage == null && cartItemAdjust.priceItem != 0" class="ml-2 mr-auto cursor-pointer" @click="clickEdit()" src="@/assets/icon/ic-edit-brown.svg" />
                    <img v-else-if="isSubscription" class="ml-2 mr-auto cursor-pointer" @click="clickEdit()" src="@/assets/icon/ic-edit-brown.svg" />
                    <div class="mr-0 ml-auto font-bold text-14 lg:text-16">
                        <div class="flex flex-shrink-0 gap-0.5">
                            <div v-if="cartItem.info1" class="line-through text-a-brown-9f8273">{{ cartItemAdjust.originalPrice }}</div>
                            <div>{{getPrice()}}</div>
                        </div>
                    </div>
                </div>
                <div class="flex w-full pt-2" v-if="cartItem.cartInvalidErrorMessage == null && cartItemAdjust.priceItem != 0">
                    <img class="mr-0 ml-auto cursor-pointer" @click="clickDelete()" v-if="cartItemAdjust.quantity == 1" src="@/assets/icon/ic-bin-brown.svg" />
                    <img class="mr-0 ml-auto cursor-pointer" @click="clickReduce()" v-if="cartItemAdjust.quantity > 1" src="@/assets/icon/ic-delete-red.svg" />
                    <div class="mr-0 ml-2 text-14 my-auto lg:text-16" >{{FilterNumberFormat(cartItemAdjust.quantity)}}</div>
                    <img class="mr-0 ml-2 cursor-pointer" @click="clickAdd()" v-if="!cartItem.info1" src="@/assets/icon/ic-add-red.svg" />
                </div>
                <div class="flex w-full pt-2" v-else-if="isSubscription">
                    <img class="mr-0 ml-auto cursor-pointer" @click="clickDelete()" v-if="cartItemAdjust.quantity == 1" src="@/assets/icon/ic-bin-brown.svg" />
                    <img class="mr-0 ml-auto cursor-pointer" @click="clickReduce()" v-if="cartItemAdjust.quantity > 1" src="@/assets/icon/ic-delete-red.svg" />
                    <div class="mr-0 ml-2 text-14 my-auto lg:text-16" >{{FilterNumberFormat(cartItemAdjust.quantity)}}</div>
                    <img class="mr-0 ml-2 cursor-pointer" @click="clickAdd()" v-if="!cartItem.info1" src="@/assets/icon/ic-add-red.svg" />
                </div>
            </div>
            <div class="w-full mt-1" v-if="cartItem.info1">
                <div class="grid grid-cols-2 gap-1 bg-a-yellow-ffd47f py-1 px-2 rounded-10">
                    <div class="font-bold text-14">{{ lbl.subscription.buy.package }}</div>
                    <div class="text-a-red-d62300 text-14 text-1-line text-right">{{ cartItem.subscriptionDetailName }}</div>
                </div>
            </div>
        </div>

        <div class="w-full flex pt-4" v-if="cartItem.cartInvalidErrorMessage != null">
            <div class="text-14 lg:text-16 text-a-red-d14545">{{lbl.shoppingcart.error_cart_item}}</div>
            <img class="cursor-pointer" @click="clickDelete()" src="@/assets/icon/ic-bin-red.svg" />
        </div>
    </div>
</template>

<script>
//mixin
import LocaleMixin from '@/mixin/LocaleMixin';
export default {
    name: "CartOrderItem",
    mixins: [LocaleMixin],
    props: {
        cartItem:  { type: Object }
    },
    components: {

    },
    data: function() {
        return {
            cartItemAdjust: null,
            reload: false,
            isSubscription: false
        }
    },
    computed: {
    },
    created: function() {
        this.cartItemAdjust = this.cartItem;
        this.isSubscription = this.cartItemAdjust.subscriptionDetailName != null && this.cartItemAdjust.subscriptionName != null ? true : false;
        this.reload = true;
    },
    methods: {
        clickAdd: function() {
            this.reload = false;
            this.cartItemAdjust.setQuantity(this.cartItemAdjust.quantity + 1);
            this.$nextTick(() => {
                this.reload = true;
            });
            this.$emit('updateItem');
        },
        clickReduce: function() {
            this.reload = false;
            this.cartItemAdjust.setQuantity(this.cartItemAdjust.quantity - 1);
            this.$nextTick(() => {
                this.reload = true;
            });
            this.$emit('updateItem');
        },
        clickDelete: function() {
            this.$emit('deleteItem');
        },
        clickEdit: function() {
            this.$emit('editOrder');
        },
        getName: function() {
            if (this.cartItem) {
                if (this.localeCode == 1033) {
                    return this.cartItemAdjust.nameEng;
                } else {
                    return this.cartItemAdjust.name;
                }
            } else {
                return "";
            }
        },
        getSideCampaign: function(sideCampaigns) {
            if (this.localeCode == 1033) {
                return sideCampaigns.nameEng;
            } else {
                return sideCampaigns.name;
            }
        },
        getPrice: function() {
            if (this.cartItemAdjust.priceItem != 0) {
                return this.FilterNumberFormat(this.cartItemAdjust.priceItem) + " " + this.lbl.shoppingcart.baht;
            } else {
                return this.lbl.shoppingcart.free;
            }

        },
        getPriceOption: function(item) {
            if(item.priceperunit > 0){
                return `(+${item.priceperunit} ${this.lbl.productDetail.priceUnit})`
            }
            return ''
        }
    }

}
</script>

<style lang="scss" scoped>
    @import "@/style/base/text.scss";
    .wrapper-order {
        width: calc(100% - 115px);
        .name-order {
            @extend %ellipsis-2;
        }
    }
    .wrapper-control {
        width: 115px;
    }

</style>
